const FormLocalStorage = 'formStore';

export default FormLocalStorage;
